import React from 'react'
import ChangePassword from './changepassword'

export default class ResetPassword extends React.Component {

  render () {
    const {router} = this.props
    const resetLink = router.location.query && router.location.query.resetlink
    const userId = router.location.query && router.location.query.id
    if (resetLink === undefined) {
      return (
        <p>Content not found</p>
      )
    } else {
      return (
        <ChangePassword resetLink={resetLink} userId={userId} />
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/memberinvitation/index.js